import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/best-selling-products/best-selling-products.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/faq/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/feature-product/feature-product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesSlider"] */ "/app/components/FeaturesSlider/FeaturesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hero-section/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/special-offfer/special-offer.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
